/**
 * burger
 */

// Module dependencies
import 'protons';

// Module styles
import './_burger.scss';

// Module template
import './_burger.twig';

export const name = 'burger';

export const defaults = {
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { burger = {} }) {
  const el = document.querySelector('.hamburger');
  const $menu = $('.primary-menu');
  const $utility = $('.utility-wrapper');
  const animationDuration = 500;
  if (el) {
    el.onclick = function() {
      el.classList.toggle('is-active');
      if ($(el).hasClass('is-active')) {
        // Display the mobile menu.
        $menu.stop(true, true).fadeIn({ duration: animationDuration, queue: false }).css('display', 'none').slideDown(animationDuration);
        $utility.fadeIn(animationDuration).css('display', 'flex');
      }
      else {
        $menu.stop(true, true).fadeOut({ duration: animationDuration, queue: false }).slideUp(animationDuration);
        $utility.fadeOut(animationDuration);
      }
    }
  }
}

export default enable;
